import { render, staticRenderFns } from "./cascader-address-widget.vue?vue&type=template&id=c3cf143e&scoped=true"
import script from "./cascader-address-widget.vue?vue&type=script&lang=js"
export * from "./cascader-address-widget.vue?vue&type=script&lang=js"
import style0 from "./cascader-address-widget.vue?vue&type=style&index=0&id=c3cf143e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3cf143e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3cf143e')) {
      api.createRecord('c3cf143e', component.options)
    } else {
      api.reload('c3cf143e', component.options)
    }
    module.hot.accept("./cascader-address-widget.vue?vue&type=template&id=c3cf143e&scoped=true", function () {
      api.rerender('c3cf143e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/cascader-address-widget.vue"
export default component.exports